import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUploadAIChatFilesMutation() {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({
			files,
			impersonationContext,
		}: {
			files: File[];
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			const formData = new FormData();
			for (const file of files) {
				formData.append('files', file);
			}
			return new Promise<Api.IBulkOperationResult<Api.IFileAttachmentWithURL>>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceWithBulkOperationResult<Api.IFileAttachmentWithURL>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: `attachment/aiChatFiles`,
						impersonationContext,
					}),
					'POST',
					formData,
					resolve,
					reject
				);
			});
		},
	});
}
